module.exports = __webpack_public_path__ + "img/UTGREA-3.24978c8e.jpg";